import React from 'react'
import Card from '@components/V3/Card'

export default function Skeleton() {
  return (
    <Card
      transparentOnDesktop
      className="w-full max-w-[1024px] flex flex-col justify-center items-center md:items-start md:justify-start">
      <div className="flex flex-col animate-pulse md:mr-auto md:mb-4">
        <div className="w-32 h-24 bg-gray-200 dark:bg-zinc-600 rounded"></div>
      </div>
    </Card>
  )
}
